import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireAuthGuardModule } from '@angular/fire/auth-guard';
import { AngularFirestoreModule, EnablePersistenceToken, FirestoreSettingsToken } from '@angular/fire/firestore';
import 'firebase/firestore';

import { environment } from '../environments/environment';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WeekSelectorComponent } from './layout/week-selector/week-selector.component';
import { ScheduledComponent } from './layout/scheduled/scheduled.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { OdlComponent } from './odl/odl.component';

import { DatePipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

// FontAwesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OdlEditComponent } from './odl-edit/odl-edit.component';
import { OdlAddnewComponent } from './odl-addnew/odl-addnew.component';
import { OdlFormComponent } from './layout/odl-form/odl-form.component';
import { OdlModalDayComponent } from './odl-modal-day/odl-modal-day.component';

import { OdlAdminComponent } from './odl-admin/odl-admin.component';
import { OdlAdminMezziComponent } from './odl-admin/mezzi/mezzi.component';
import { OdlAdminAutistiComponent } from './odl-admin/autisti/autisti.component';
import { OdlAdminUtentiComponent } from './odl-admin/utenti/utenti.component';
import { OdlAdminOrdiniComponent } from './odl-admin/ordini/ordini.component';

import { ServiceWorkerModule } from '@angular/service-worker';
import { HeaderNuovoOrdineComponent } from './layout/header-nuovo-ordine/header-nuovo-ordine.component';
import { HeaderModificaOrdineComponent } from './layout/header-modifica-ordine/header-modifica-ordine.component';
import { HttpClientModule } from '@angular/common/http';
import { PrintRapportinoMod4Component } from './layout/print-rapportino-mod4/print-rapportino-mod4.component';
import { PrintRapportinoMod4EComponent } from './layout/print-rapportino-mod4-e/print-rapportino-mod4-e.component';
import { PrintRapportinoMod5Component } from './layout/print-rapportino-mod5/print-rapportino-mod5.component';
import { OdlStatsComponent } from './odl-stats/odl-stats.component';
import { OdlYearSelectorComponent } from './layout/odl-year-selector/odl-year-selector.component';
import { OdlStatsFiltersComponent } from './layout/odl-stats-filters/odl-stats-filters.component';
import { OdlStatsReportComponent } from './layout/odl-stats-report/odl-stats-report.component';
import { HeaderReportComponent } from './layout/header-report/header-report.component';
import { ChartsModule } from 'ng2-charts';
import { ReportGeneraleComponent } from './odl-stats-report/report-generale/report-generale.component';
import { ReportTipoInterventoComponent } from './odl-stats-report/report-tipo-intervento/report-tipo-intervento.component';
import { ReportTipoClienteComponent } from './odl-stats-report/report-tipo-cliente/report-tipo-cliente.component';
import { LoginComponent } from './login/login.component';
import { SearchinpageComponent } from './layout/searchinpage/searchinpage.component';
import { NoMidnightPipe } from './no-midnight.pipe';

registerLocaleData(localeIt);

@NgModule({
    declarations: [
        AppComponent,

        OdlComponent,
        HeaderComponent,
        WeekSelectorComponent,
        ScheduledComponent,
        FooterComponent,
        OdlEditComponent,
        OdlAddnewComponent,
        OdlFormComponent,
        OdlModalDayComponent,
        OdlAdminComponent,
        OdlAdminMezziComponent,
        OdlAdminAutistiComponent,
        OdlAdminUtentiComponent,
        OdlAdminOrdiniComponent,
        HeaderNuovoOrdineComponent,
        HeaderModificaOrdineComponent,
        PrintRapportinoMod4Component,
        PrintRapportinoMod4EComponent,
        PrintRapportinoMod5Component,
        OdlStatsComponent,
        OdlYearSelectorComponent,
        OdlStatsFiltersComponent,
        OdlStatsReportComponent,
        HeaderReportComponent,
        ReportGeneraleComponent,
        ReportTipoInterventoComponent,
        ReportTipoClienteComponent,
        LoginComponent,
        SearchinpageComponent,
        NoMidnightPipe,

    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        AngularFireModule.initializeApp(environment.firebase),
        // AngularFirestoreModule,
        // AngularFirestoreModule.enablePersistence(),  // Attiva la cache, ma c'è un calo di prestazioni esagerato.
        // environment.production ? AngularFirestoreModule.enablePersistence() : AngularFirestoreModule,
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireAuthGuardModule,

        NgbModule,          // In alternativa caricare solo i moduli richiesti ( NgbPaginationModule, NgbAlertModule, ...)
        FontAwesomeModule,
        ChartsModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ],

    providers: [
        DatePipe,
        { provide: EnablePersistenceToken, useValue: localStorage.getItem('persistence') && localStorage.getItem('persistence') === 'on' },
        { provide: FirestoreSettingsToken, useValue: { cacheSizeBytes: 1048576, experimentalForceLongPolling: true } },
        { provide: LOCALE_ID, useValue: 'it' },

    ],

    bootstrap: [AppComponent],

    entryComponents: [
        OdlModalDayComponent
    ]
})
export class AppModule {
    /*
    constructor(private afs: AngularFirestore) {
        afs.firestore.settings({
            // timestampsInSnapshots: true,
            cacheSizeBytes: 1048577,
            // cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
        });
        // afs.firestore.enablePersistence();
    }
    */

}
